// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-center[data-v-d9085c26] {\n  text-align: center;\n}\n.forgot-password-link[data-v-d9085c26] {\n  color: #2F64A3;\n}\n.forgot-password-link[data-v-d9085c26]:hover {\n  text-decoration: underline;\n}\n", ""]);
// Exports
module.exports = exports;
